const MobileText = ({text}) => {
  return(
    <div style={{
      overflowWrap: 'break-word',
      maxWidth: "500px",
      fontFamily: "ff-scala",
      fontSize: "18px",
      color: "black",
      paddingRight: "10px",
      paddingLeft: "0px"
    }}>
      {text}
    </div>
  )
}

export default MobileText;